import { render } from "./NetworkDeviceDetails.vue?vue&type=template&id=bbc2c0f0"
import script from "./NetworkDeviceDetails.vue?vue&type=script&lang=js"
export * from "./NetworkDeviceDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__